'use client';

import { FC } from 'react';
import { RichTextField } from '@prismicio/client';
import classNames from 'classnames';
import { isFilled } from '@prismicio/helpers';
import { PrismicRichText } from '@prismicio/react';
import { htmlSerializer } from 'utils/serializer';

const MainContent: FC<{
  content: RichTextField | null | undefined;
}> = ({ content }) => {
  return (
    <article className={classNames('content', 'blog-article__content')}>
      {isFilled.richText(content) && (
        <PrismicRichText components={htmlSerializer} field={content} />
      )}
    </article>
  );
};

export default MainContent;
